import moment from "moment"
export default {
    name: 'HistoryTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedChangelogItem: null
        }
    },
    computed: {
        hasChangelog() {
            return this.recallData &&
             this.recallData.changelog &&
             Array.isArray(this.recallData.changelog) &&
             this.recallData.changelog.length > 0
        },

        sortedChangelog() {
            if (!this.hasChangelog) return []

            return [...this.recallData.changelog].sort((a, b) =>
                new Date(b.timestamp) - new Date(a.timestamp)
            )
        }
    },
    watch: {
        sortedChangelog: {
            handler(newChangelog, oldChangelog) {
                if (newChangelog.length > 0) {
                    // If changelog has changed (new data loaded), select the first item
                    if (!oldChangelog || oldChangelog.length !== newChangelog.length || !this.selectedChangelogItem) {
                        this.selectedChangelogItem = newChangelog[0]
                    }
                    // If the currently selected item doesn't exist in new data, select first item
                    else if (!newChangelog.find(item => item.timestamp === this.selectedChangelogItem?.timestamp)) {
                        this.selectedChangelogItem = newChangelog[0]
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        selectChangelogItem(entry) {
            this.selectedChangelogItem = entry
        },

        formatDateTime(date) {
            if (!date) return '-'
            try {
                const d = new Date(date)
                if (isNaN(d.getTime())) return '-'
                return d.toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                })
            } catch (error) {
                return '-'
            }
        },

        getFieldDisplayName(fieldName) {
            const displayNames = {
                'recall_name': 'Recall Name',
                'recall_id': 'Recall ID',
                'recall_date': 'Recall Date',
                'recalling_firm': 'Recalling Firm',
                'manufacturer': 'Manufacturer',
                'response_email': 'Response Email',
                'urgent': 'Urgent',
                'description': 'Description',
                'health_risk': 'Health Risk',
                'actions': 'Actions',
                'recall_type': 'Recall Type',
                'fda_classification': 'FDA Classification',
                'isVoluntary': 'Is Voluntary',
                'instructions': 'Instructions',
                'recall_category': 'Recall Category',
                'additional_contact_info': 'Additional Contact Info',
                'product_list': 'Products',
                'correction': 'Correction',
                'status': 'Status'
            }

            return displayNames[fieldName] || fieldName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
        },

        formatValueForDisplay(value, fieldName = '') {
            if (value === null || value === undefined) return '(empty)'
            if (value === '') return '(empty string)'
            if (fieldName && fieldName.toLowerCase().includes('urgent')) {
                if (value === true || value === 'true' || value === 'TRUE') return 'YES'
                if (value === false || value === 'false' || value === 'FALSE') return 'NO'
            }
            const dateFields = [
                'recall_date',
                'distribution_start_date',
                'distribution_end_date',
                'expiration_start_date',
                'expiration_end_date',
                'manufactured_start_date',
                'manufactured_end_date'
            ]
            // Check if the field name (including nested fields like product_1.distribution_start_date) contains any date field
            const isDateField = dateFields.some(dateField =>
                fieldName.toLowerCase().includes(dateField)
            )
            if (isDateField) {
                const date = new Date(value)
                if (!isNaN(date.getTime())) {
                    return moment(value).format('MM/DD/YYYY')
                }
            }
            if (typeof value === 'object') return JSON.stringify(value, null, 2)
            return String(value)
        }
    }
}
